const verifiedPhoneNumbers = function (state) {
  return state.callerIDs.map((callerID: any) => callerID.phoneNumber)
}

export default verifiedPhoneNumbers
